import mutations from './mutations.js';
import getters from './getters.js';
import actions from './actions.js';
export default {
  namespaced: true,
  state() {
    return {
      iframe_src: '',
      iframe_title: '',
      iframe_visible: false,
      video_src: '',
      video_title: '',
      video_captions: '',
      video_transcript: '',
      video_visible: false,
      help_popup_visible: false,
      focusElemOnPopupClose: '',
    };
  },
  mutations,
  actions,
  getters,
};
